import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { catchError, EMPTY, map, Observable } from 'rxjs';
import { webRedirectionUrl } from '../constants/web-redirection-url';
import { ApiService } from '../services/api.service';
import { UtilityService } from '../services/utility.service';
import { NavigationService } from '../services/navigation.service';

export const competitionDetailsResolver: ResolveFn<Observable<any>> = (
  route: ActivatedRouteSnapshot,
) => {
  const slug: string = route.params['slug'];
  const router = inject(Router);
  const apiService = inject(ApiService);
  const utilityService = inject(UtilityService);
    const navigationService = inject(NavigationService)

  if (utilityService.isUserLoggedIn()) {
    const url = `${webRedirectionUrl.competitionDetails}${slug}`;
    utilityService.saveUrlandRedirect(url);
    return EMPTY;
  } else {
    return apiService.getCompetitionDetails(slug).pipe(
      map((resp) => {
        if (resp.header.success && resp.data) {
          return resp.data;
        }

        throw new Error(resp.header.msg);
      }),
      catchError((error) => {
       navigationService.handleResolverError(error)
        return EMPTY;
      }),
    );
  }
};
